// First, so that it holds the fetch of the browser before any library wraps it.
import "src/lib/native-fetch";
import "src/lib/sentry";
import "src/lib/datadog";

import { createRoot } from "react-dom/client";
// biome-ignore lint/style/noRestrictedImports: legacy suppression
import { wrapCreateBrowserRouter } from "@sentry/react";
import { createBrowserRouter as createDatadogBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";
// biome-ignore lint/style/noRestrictedImports: legacy suppression
import { RouterProvider } from "react-router-dom";

import { installBoundedMediaRangeFetch } from "@hightouch/ad-studio-renderer/bounded-range-fetch";
import { installSettingsPopStateListener } from "src/components/layout/settings-history";
import { installChunkLoadErrorHandler } from "src/lib/chunk-reload";
import { setupCustomPluralizations } from "src/lib/custom-pluralizations";
import { filterConsoleErrors } from "src/utils/logs";
import { routes } from "./components/router";
import { RootProviders } from "./components/app/providers";

installChunkLoadErrorHandler();
installBoundedMediaRangeFetch();
setupCustomPluralizations();
// Before the router, whose own popstate listener would otherwise run first.
installSettingsPopStateListener();

const root = createRoot(document.getElementById("react")!);

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(
  createDatadogBrowserRouter,
);
const router = sentryCreateBrowserRouter(routes);

filterConsoleErrors();

root.render(
  <RootProviders>
    <RouterProvider router={router} fallbackElement={null} />
  </RootProviders>,
);
